import { HttpService } from "../../modules/shared/services/http.service";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

export interface TrustpilotSettings {
  id?: string;
  enabled: boolean;
  delayDays: number;
  reviewPageUrl: string;
  localeUrls: Record<string, string>;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface TrustpilotStats {
  totalSent: number;
  sentLast30Days: number;
  sentToday: number;
}

export interface TrustpilotInvitation {
  id: string;
  invoiceNumber: string;
  recipientEmail: string;
  recipientName: string;
  sentAt: string;
  invoiceDate: string;
  amount: number;
  currency: any;
}

export interface TrustpilotHistoryResponse {
  data: TrustpilotInvitation[];
  total: number;
  page: number;
  limit: number;
}

export interface UpdateTrustpilotSettingsDto {
  enabled?: boolean;
  delayDays?: number;
  reviewPageUrl?: string;
  localeUrls?: Record<string, string>;
}

export interface SendInvitationDto {
  userIdOrEmail: string;
  email?: string;
}

// Get Trustpilot settings
export const getTrustpilotSettings = async (): Promise<TrustpilotSettings> => {
  const response = await HttpService.get("api/v1/trustpilot/settings", true, { "x-custom-lang": "en" });
  return response;
};

// Update Trustpilot settings
export const updateTrustpilotSettings = async (data: UpdateTrustpilotSettingsDto): Promise<TrustpilotSettings> => {
  const response = await HttpService.patch("api/v1/trustpilot/settings", data, headers, true);
  return response;
};

// Get Trustpilot statistics
export const getTrustpilotStats = async (): Promise<TrustpilotStats> => {
  const response = await HttpService.get("api/v1/trustpilot/stats", true, { "x-custom-lang": "en" });
  return response;
};

// Get invitation history
export const getTrustpilotHistory = async (page: number = 1, limit: number = 50): Promise<TrustpilotHistoryResponse> => {
  const response = await HttpService.get(`api/v1/trustpilot/history?page=${page}&limit=${limit}`, true, { "x-custom-lang": "en" });
  return response;
};

// Send manual invitation
export const sendTrustpilotInvitation = async (data: SendInvitationDto): Promise<{ success: boolean; message: string }> => {
  const response = await HttpService.post("api/v1/trustpilot/send-invitation", data, headers, true);
  return response;
};

// Trigger scheduler manually
export const triggerTrustpilotScheduler = async (): Promise<{ message: string }> => {
  const response = await HttpService.post("api/v1/trustpilot/trigger-scheduler", {}, headers, true);
  return response;
};

